<template>
    <LayoutDashboard title="Fluxo de Caixa">
        <v-card outlined>
            <form @submit.prevent="imprimir">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-text-field class="mr-2 ml-2" label="Período Inicial" v-model="periodo_inicial" type="date" dense outlined required>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field class="mr-2 ml-2" label="Período Finial" v-model="periodo_final" type="date" dense outlined required>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success" outlined type="submit" block v-if="$helper.verificaPermissao('visualizar-fluxo-caixa')">Gerar Relatório</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </LayoutDashboard>
</template>
<script>
    import moment from 'moment'
    import RelatorioFinanceiroService from '@/services/RelatorioFinanceiroService'
    
    export default {
        data() {
            return {
                periodo_inicial: moment().format('YYYY-MM-DD'),
                periodo_final: moment().format('YYYY-MM-DD'),
            }
        },
        methods: {
            imprimir(){
                this.$store.commit('setOverlay', true)
                RelatorioFinanceiroService.fluxoCaixa({
                    periodo_inicial: this.periodo_inicial,
                    periodo_final: this.periodo_final
                })
                .then(res => {
                    this.$store.commit('setOverlay', false)
                    this.$store.commit('setModalPrint', res.data.pdf_link)
                })
                .catch(e => {
                    this.$store.commit('setOverlay', false)
                    this.$store.commit('snackbarError', 'Erro ao imprimir relatório.')
                    console.log(e)
                })

            }
        }
    }
</script>